import { Link } from "react-router-dom";
import { useLang } from "../../contexts/LanguageContext";

export function ArtworkCard({ artwork, className = "", aspect = "aspect-[4/5]" }) {
  const { lang, t } = useLang();
  const category = lang === "pl" ? artwork.category_pl : artwork.category_en;
  const medium = lang === "pl" ? artwork.medium_pl : artwork.medium_en;

  const inquireSubject = encodeURIComponent(`${artwork.title}`);
  const inquireBody = encodeURIComponent(
    lang === "pl"
      ? `Dzień dobry, interesuje mnie praca "${artwork.title}". Proszę o informację o jej dostępności oraz możliwości prywatnego pokazu.`
      : `Hello, I am interested in the work "${artwork.title}". Please let me know about its availability and the possibility of a private viewing.`
  );

  return (
    <article
      data-testid={`artwork-card-${artwork.slug}`}
      className={`group flex flex-col gap-5 ${className}`}
    >
      <Link
        to={`/galeria`}
        className={`block ${aspect} overflow-hidden bg-sand relative`}
        aria-label={artwork.title}
      >
        <img
          src={artwork.image}
          alt={artwork.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
        />
      </Link>
      <div className="flex flex-col gap-1">
        <div className="flex items-baseline justify-between gap-4">
          <h3 className="font-heading text-2xl md:text-[26px] font-light tracking-tight">
            {artwork.title}
          </h3>
          {artwork.year && (
            <span className="overline">{artwork.year}</span>
          )}
        </div>
        <p className="font-body text-sm font-light text-foreground/70">
          {medium}
        </p>
        <p className="overline mt-1">{category}</p>
        <a
          href={`mailto:piotr@gonzaga.pl?subject=${inquireSubject}&body=${inquireBody}`}
          data-testid={`inquire-${artwork.slug}`}
          className="mt-3 self-start link-underline text-[12px] uppercase tracking-[0.22em] font-medium"
        >
          {t.common.askAbout}
        </a>
      </div>
    </article>
  );
}
